var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DataTable',{attrs:{"goToDetail":_vm.goToDetail,"goToAdd":_vm.goToAdd,"title":_vm.title,"entityType":`${_vm.$route.meta.type}`,"endpoint":_vm.endpoint['entity']['getByFilter']}})
}
var staticRenderFns = []

export { render, staticRenderFns }